import Vue from 'vue'
import Cookies from 'js-cookie'
import Element from 'element-ui'

import registerGlobalDirectives from '@/directive/globalDirectives.js'
import registerGlobalFilters from '@/filters/globalFilters.js'
import { getFileType } from '@/utils/index'

import App from './App'
import store from './store'
import router from './router'
import './mixin'

import '@/utils/auto-regist-components.js'
import './icons' // icon
import './permission' // permission control
import './directive/permission'
import './utils/error-log' // error log
import 'vue-custom-scrollbar/dist/vueScrollbar.css'
import '@/views/formMaking/iconfont/iconfont.css'
import '@/views/formMaking/styles/index.scss'
import '@/views/formMaking/styles/cover.scss'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import '@/styles/element-variables.scss'
import '@/styles/index.scss' // global css
import '@/styles/FormGenerator/index.scss'
import 'vxe-table/lib/style.css'
import '@/utils/warpDebug.js'

registerGlobalDirectives(Vue) // 注册全局指令
registerGlobalFilters(Vue) // 注册全局过滤器

import organConfig from '@/utils/organConfig'
function setFavicon(path) {
  const link =
    document.querySelector("link[rel*='icon']") ||
    document.createElement('link')
  link.type = 'image/x-icon'
  link.rel = 'shortcut icon'
  link.href = path
  document.getElementsByTagName('head')[0].appendChild(link)
}
setFavicon(organConfig.favivon)

import versionTood from '@/api/versionUpdate'
// 定时获取版本号
setInterval(() => {
  versionTood.isNewVersion()
}, 12000)
// UploadAuth上传 兼容IE11
if (!FileReader.prototype.readAsBinaryString) {
  FileReader.prototype.readAsBinaryString = function (fileData) {
    var binary = ''
    var pt = this
    var reader = new FileReader()
    reader.onload = function (e) {
      var bytes = new Uint8Array(reader.result)
      var length = bytes.byteLength
      for (var i = 0; i < length; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      // pt.result  - readonly so assign binary
      pt.content = binary
      pt.onload()
    }
    reader.readAsArrayBuffer(fileData)
  }
}
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
  // locale: enLang // 如果使用中文，无需设置，请删除
})
require('@/plugins/index') // 组件注册
Vue.config.productionTip = false

// 全局注册 ImagePreviewer 组件
import contextmenu from '@/components/contextmenu/index.js'
Vue.prototype.$contextmenu = contextmenu

// 友盟埋点
import miniProgram from '@/utils/miniProgram'
if (process.env.CUSTOM_ENV === 'production') {
  Vue.prototype.$uweb = miniProgram
  miniProgram.init()
}

Vue.prototype.getPrColor = function (val) {
  const markColors = [
    { label: '#718637', value: 'GREEN' },
    { label: '#D22C36', value: 'RED' },
    { label: '#AF8BB1', value: 'PURPLE' },
    { label: '#E96F24', value: 'ORANGE' },
    { label: '#D0A12B', value: 'YELLOW' },
    { label: '#FFFFFF', value: 'WHITE' },
    { label: '#428DFC', value: 'BLUE' },
    { label: '#19F4D6', value: 'CYAN' }
  ]
  let markColor = val
  markColors.forEach(item => {
    if (val === item.value) {
      markColor = item.label
    }
  })
  return markColor
}
Vue.prototype.ExportExcel = function (
  list,
  tHeader2,
  merges,
  filterVal,
  title
) {
  // 导出数据
  this.list = list

  // 表头数据对应名字
  this.filterVal = filterVal
  // 数据方法
  this.formatJson = function (filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]))
  }
  // 导出文件的方法
  this.export2Excel = function () {
    require.ensure([], () => {
      const { export_json_to_excel } = require('@/Excel/Export2Excel')

      const filterVal = this.filterVal
      const list = this.list
      const data = this.formatJson(filterVal, list)
      export_json_to_excel({
        multiHeader: tHeader2,
        data,
        filename: title,
        merges
      })
    })
  }
}
Vue.prototype.ExportExcel2 = function (
  list,
  tHeader1,
  tHeader2,
  merges,
  filterVal,
  title
) {
  // 导出数据
  this.list = list

  // 表头数据对应名字
  this.filterVal = filterVal
  // 数据方法
  this.formatJson = function (filterVal, jsonData) {
    return jsonData.map(v => filterVal.map(j => v[j]))
  }
  // 导出文件的方法
  this.export2Excel2 = function () {
    require.ensure([], () => {
      const { export_json_to_excel } = require('@/Excel/Export2Excel')
      const filterVal = this.filterVal
      const list = this.list
      const data = this.formatJson(filterVal, list)
      export_json_to_excel({
        multiHeader: tHeader1,
        multiHeader2: tHeader2,
        data,
        filename: title,
        merges
      })
    })
  }
}
Vue.prototype.$getUuiD = randomLength => {
  return (
    Number(
      Math.random().toString().substr(2, randomLength) + Date.now()
    ).toString(36) +
    Math.floor(Math.random() * 10) +
    1
  )
}
Vue.prototype.$getFileType = getFileType

// 导入引用弹出框功能
import {
  initCitationPopovers,
  destroyCitationPopovers,
  setCitationsData,
  updateCitationData,
  getCitationsData
} from '@/ai-poputer'
// 将引用弹出框功能注册为全局方法

Vue.prototype.$initCitationPopovers = function (container, data, messageId) {
  initCitationPopovers(container, data, messageId)
}
Vue.prototype.$destroyCitationPopovers = destroyCitationPopovers

Vue.prototype.$setCitationsData = function (data, messageId) {
  setCitationsData(data, messageId)
}
Vue.prototype.$updateCitationData = updateCitationData
Vue.prototype.$getCitationsData = getCitationsData

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
